import cn from "classnames";
import Address from "components/shared/address";
import ForwardingSource from "components/shared/forwardingSource";
import Loader from "components/shared/loader";
import { getShortAddress } from "helpers/bidpoint";
import { dateToView } from "helpers/date";
import { ORDER_PRICE_TYPE_ENUM } from "helpers/forwarding";
import { paths } from "helpers/paths";
import { formatNumber, ymEvent } from "helpers/system";
import cloneDeep from "lodash/cloneDeep";
import React, { useEffect, useState } from "react";
import { CustomScroll } from "react-custom-scroll";
import { myCargorunOrderTruckMatchings } from "sources/forwarding";

const matchingStatusEnumMapper = {
    10: "awaiting",
    20: "declined",
    30: "accepted",
    40: "declined",
};

const bidsDefaultState = {
    accepted: [],
    awaiting: [],
    declined: [],
};

const ExternalBids = (props) => {
    const [isLoading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState("accepted");
    const [bids, setBids] = useState(cloneDeep(bidsDefaultState));
    const refreshList = () => {
        setLoading(true);
        myCargorunOrderTruckMatchings().then((data) => {
            const newBids = (data?.data || []).reduce((acc, item) => {
                acc[matchingStatusEnumMapper[item.status]].push(item);
                return acc;
            }, cloneDeep(bidsDefaultState));
            setBids(newBids);
            setLoading(false);
            props.setCountOfAcceptedExternal(newBids.accepted.length);
        });
    };

    useEffect(() => {
        if (props.listOpened) {
            ymEvent("AcceptedDisBidsListViewed");
            refreshList();
        }
    }, [props.listOpened]);

    const getAddress = (geozone) => <Address address={getShortAddress(geozone)} />;

    const createBidByMatchingId = (matchingId, cargorunId) => {
        ymEvent("DisBidsToBidCreated");
        return window.open(`${paths.bidNew}?matchingId=${matchingId}&cargorunId=${cargorunId}`);
    };

    const renderBody = () => {
        return (
            <>
                <div className="external-bids__head border-bottom border-secondary">
                    <span>Экспедиционные заказы</span>
                    <div className="external-bids__head--close" onClick={() => props.setListOpened(!props.listOpened)}>
                        &times;
                    </div>
                </div>
                <div className="external-bids__toggler">
                    <div
                        onClick={setActiveTab.bind(this, "accepted")}
                        className={cn("external-bids__toggler-item", {
                            "external-bids__toggler-item--active": activeTab === "accepted",
                        })}
                    >
                        <span
                            className={cn("position-relative", {
                                "external-bids__toggler-item--new": bids.accepted.length > 0,
                            })}
                        >
                            Одобрены
                        </span>
                    </div>
                    <div
                        onClick={setActiveTab.bind(this, "awaiting")}
                        className={cn("external-bids__toggler-item", {
                            "external-bids__toggler-item--active": activeTab === "awaiting",
                        })}
                    >
                        <span
                            className={cn("position-relative", {
                                "external-bids__toggler-item--new": bids.awaiting.length > 0,
                            })}
                        >
                            В ожидании
                        </span>
                    </div>
                    <div
                        onClick={setActiveTab.bind(this, "declined")}
                        className={cn("external-bids__toggler-item", {
                            "external-bids__toggler-item--active": activeTab === "declined",
                        })}
                    >
                        <span
                            className={cn("position-relative", {
                                "external-bids__toggler-item--new": bids.declined.length > 0,
                            })}
                        >
                            Отказы
                        </span>
                    </div>
                </div>
                <div
                    className={cn("external-bids__list fade-in", {
                        "external-bids__list--empty": bids[activeTab].length === 0,
                    })}
                    key={activeTab}
                >
                    {bids[activeTab].length > 0 ? (
                        <CustomScroll heightRelativeToParent="100%">
                            {bids[activeTab].map((bid) => {
                                const {
                                    id,
                                    truckNumber,
                                    firstPoint,
                                    lastPoint,
                                    price,
                                    orderPriceType,
                                    counterpartyName,
                                    acceptedAt,
                                    outputWithoutEmptyMileage,
                                    organizationId,
                                    organizationName,
                                    organizationHasLogo,
                                    documentsLink,
                                    cargorunId,
                                } = bid;
                                return (
                                    <div key={id} className="external-bids__list-item border-bottom border-secondary">
                                        <div className="external-bid__line">
                                            <div className="external-bid__number">{truckNumber}</div>
                                            <div>
                                                <span className="badge badge-primary">{counterpartyName}</span>
                                            </div>
                                        </div>
                                        {organizationId && (
                                            <div className="external-bid__line">
                                                <ForwardingSource
                                                    name={organizationName}
                                                    knowledgeBaseUrl={documentsLink}
                                                    iconUrl={
                                                        organizationHasLogo
                                                            ? paths.forwardingOrganizationLogo(organizationId)
                                                            : undefined
                                                    }
                                                />
                                            </div>
                                        )}
                                        <div className="external-bid__line">
                                            <div className="d-flex align-items-center position-relative">
                                                <div className="external-bid__circle external-bid__circle--start" />
                                                <div className="external-bid__circle--line" />
                                                <span className="external-bid__city">
                                                    {getAddress(firstPoint.location)}
                                                </span>
                                            </div>
                                            <div>{dateToView(acceptedAt)}</div>
                                        </div>
                                        <div className="external-bid__line">
                                            <div className="d-flex align-items-center">
                                                <div className="external-bid__circle" />
                                                <span className="external-bid__city">
                                                    {getAddress(lastPoint.location)}
                                                </span>
                                            </div>
                                            <div className="external-bid__price">
                                                {price ? (
                                                    <>
                                                        {formatNumber(price, {
                                                            style: "currency",
                                                            currency: props.organization?.currency,
                                                        })}
                                                        &nbsp;
                                                        <span className="text-muted">
                                                            ({formatNumber(outputWithoutEmptyMileage)}{" "}
                                                            {props.organization?.currencyData?.name}/км)
                                                        </span>
                                                    </>
                                                ) : (
                                                    <small>Стоимость не указана</small>
                                                )}
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-end">
                                            <span
                                                className={cn("badge badge-pill", {
                                                    "badge-primary": orderPriceType === 10,
                                                    "badge-info": orderPriceType === 20,
                                                    "badge-success": orderPriceType === 30,
                                                })}
                                            >
                                                {ORDER_PRICE_TYPE_ENUM[orderPriceType]}
                                            </span>
                                        </div>
                                        {activeTab === "accepted" && cargorunId && (
                                            <div className="pt-2">
                                                <div
                                                    className="btn btn-xs btn-outline-primary"
                                                    onClick={() => createBidByMatchingId(id, cargorunId)}
                                                >
                                                    Создать заявку
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </CustomScroll>
                    ) : (
                        <div className="text-center">
                            <i className="icon-uEAB6-search-truck external-bids__list--empty-icon" />
                            <div className="external-bids__list--empty-text">
                                Ничего не найдено.
                                <br />
                                Попробуйте сменить статус.
                            </div>
                        </div>
                    )}
                </div>
            </>
        );
    };

    return (
        <div className="external-bids__container">
            <div className={cn("external-bids__list-wrap", { "external-bids__list-wrap--opened": props.listOpened })}>
                {isLoading && (
                    <>
                        <div className="loader-snippet--disable-loader" />
                        <Loader wrapCname="content-center d-flex justify-content-center flex-column h-100" />
                    </>
                )}
                {renderBody()}
            </div>
        </div>
    );
};

export default ExternalBids;
